<template>
    <div class="home">
        <div>
            <el-row :gutter="10" class="titleNew">
                <el-col :span="3"><img src="../../assets/images/header-logo-2.png" alt=""></el-col>
                <el-col :span="7"><div class="text">上海工程咨询网</div></el-col>     
                <el-col :span="14"  :model="searchInfo">
                    <el-input class="shuru" v-model="searchInfo.findContent" clearable placeholder="请输入" size="mini">
                        <el-button type="primary" class="input-b" @click="goTotalSearch" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
                <!-- <el-col :span="1"> -->
            <!-- </el-col> -->
            </el-row>
        </div>

        <div class="f-d">
            <span>创新</span>
            <span>协调</span>
            <span>绿色</span>
            <span>开放</span>
            <span>共享</span>
        </div>
        <el-carousel class="banner" :interval="3000" >
              <el-carousel-item v-for="item in images" :key="item.id" >
                <img :src="require('../../assets/images/moblie/'+item)" height="400" />
              </el-carousel-item>
        </el-carousel>
        <el-row class="link">
            <el-col :span="9">
                <div @click="link1">
                    <img src="../../assets/images/newHome/行业动态.png" alt="">
                    <div>行业动态</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div @click="link2">
                    <img src="../../assets/images/newHome/会员动态.png" alt="">
                    <div>会员动态</div>
                </div>
            </el-col>
            <el-col :span="9">
                <div @click="link3">
                    <img src="../../assets/images/newHome/协会工作.png" alt="">
                    <div>协会工作</div>
                </div>
            </el-col>
        </el-row>
        <el-row class="link">
            <el-col :span="9">
                <div @click="link4">
                  <!-- <a href="#link"> -->
                    <img src="../../assets/images/newHome/服务平台.png" alt="">
                    <div>服务平台</div>
                  <!-- </a>                 -->
                </div>
            </el-col>
            <el-col :span="6">
                <div @click="link5">
                    <img src="../../assets/images/newHome/优秀成果.png" alt="">
                    <div>优秀成果</div>
                </div>
            </el-col>
            <el-col :span="9">
                <div @click="link6">
                    <img src="../../assets/images/newHome/行业自律.png" alt="">
                    <div>行业自律</div>
                </div>
            </el-col>
        </el-row>
        <el-row class="link">
            <el-col :span="9">
                <div @click="link7">
                    <img src="../../assets/images/newHome/政策法规.png" alt="">
                    <div>政策法规</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div @click="link8">
                    <img src="../../assets/images/newHome/人才建设.png" alt="">
                    <div>人才建设</div>
                </div>
              
            </el-col>
            <el-col :span="9">
                <div @click="link9">
                    <img src="../../assets/images/newHome/党建园地.png" alt="">
                    <div>党建园地</div>
                </div>
            </el-col>
        </el-row>
        <div class="news">
            <div class="news-title">
                <span class="title-1">________</span>
                <span class="title-2">新闻资讯</span>
                <span class="title-3">________</span>
            </div>
            <div class="news-title2">News</div>
            <div>
                <el-carousel :interval="4000" type="card" indicator-position="none" height="300px" class="karp">
                  <el-carousel-item  v-for="(item, index) in industryDynamicList" :key="index" class="karp-bkg">
                    <div  @click="jumpDocInfo(item.doc_id)" >
                    <div v-for="(img, i) in imageList" :key="i" class="karp-nei">            
                        <img :src="img.img" alt="" class="karp-img">                                                          
                    </div>          
                    <div class="text">
                        <div class="karp-title line1">{{item.industry_title}}}</div>
                        <div class="karp-content line2"><span v-html="item.industry_content"></span></div>  
                    </div> 
                    <div class="hengxian"></div>
                    <div class="day">
                        <div class="day-time">
                            <div class="day-time1">{{item.showDate.substring(8,10)}}</div>
                            <div class="day-time2">{{item.showDate.substring(0, 7)}}</div>
                        </div>
                        <div class="day-img">
                            <img  src="../../assets/images/newHome/jiantao.png"  class=""/>
                        </div>                      
                    </div>
                </div>
                  </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="mt-30 " name="link">
            <div class="news-title">
                <span class="title-1">________</span>
                <span class="title-2">工程资讯单位</span>
                <span class="title-3">________</span>
            </div>
            <div class="news-title2 mb-20">Engineering consulting unit</div>
            <el-row :gutter="20" class="h-260">
            <el-col :span="6" :xs="6" class="border-r" >
              <div @click="goRsj('http://zhywglxt.cnaec.com.cn/#/consultant_login')" style="cursor:pointer">
                <img src="../../assets/images/home/综合业务管理系统.png" />
                <a href="#" ><p class="mt fw700">综合业务管理系统</p></a>
              </div>
            </el-col>
            <el-col :span="6" :xs="6" class="border-r">
              <div @click="goRsj('https://zxgcsjxjy.lanmaiedu.com/')" style="cursor:pointer">
                <img src="../../assets/images/home/继续教育平台.png" />
                <a href="#"><p class="mt fw700">继续教育平台</p></a>
              </div>
            </el-col>
            <el-col :span="6" :xs="6" class="border-r">
              <div  @click="goGaozhiDetail('9f2091e816194dc88a0f2b98482dcd45')">
                <img src="../../assets/images/home/告知性备案系统.png" />
                <p class="mt fw700">告知性备案系统</p>
              </div>
            </el-col>
            <el-col :span="6" :xs="6" class="mtp">
              <div @click="goRsj('http://www.rsj.sh.gov.cn/spta.shtml')" style="cursor:pointer">
                <img src="../../assets/images/home/考试报名系统.png" />
                <a href="#"><p class="mt fw700">考试报名系统</p></a>
              </div>
            </el-col>
        </el-row>
        </div>
        <div class="mt-20">
            <div class="news-title">
                <span class="title-1">________</span>
                <span class="title-2">网上办事系统</span>
                <span class="title-3">________</span>
            </div>
            <div class="news-title2 mb-20">Online affairs</div>
            <el-row :gutter="20" class="h-260">
            <el-col :span="8" :xs="8" class="border-r">
              <div @click="handleJump('/XAbout?tab=7')" style="cursor:pointer">
                <img src="../../assets/images/home/加入协会.png" />
                <p class="mt fw700">加入协会</p>
              </div>
            </el-col>
            <el-col :span="8" :xs="8" class="border-r">
              <div  @click="goOASystem" style="cursor:pointer">
                <img src="../../assets/images/home/协会网上办事系统.png" />
                <p class="mt fw700">协会网上办事系统</p>
              </div>
            </el-col>
            <el-col :span="8" :xs="8">
              <div  @click="handleJump('/XInquiry')" style="cursor:pointer">
                <img src="../../assets/images/home/查询专区.png" />
                <p class="mt fw700">查询专区</p>
              </div>
            </el-col>
        </el-row>
        </div>
        <div class="home-hy">
            <div class="news-title">
                <span class="title-1">________</span>
                <span class="title-2">行业精英</span>
                <span class="title-3">________</span>
            </div>
            <div class="news-title2 mb-20">Industry elite</div>
            <el-row  :gutter="20" class="wai">
                <el-col  :span="24" :xs="24">                      
                <el-carousel :interval="4000" type="card" indicator-position="none" height="350px">
                  <el-carousel-item v-for="(item, i) in eliteList" :key="i">
                    <div @click="handlePersonInfo(item.doc_id)" class="hangye">
                      <div class="hangye-img">
                        <img class="hangye-img1" :src="item.img_url" alt="" srcset="" />
                      </div>
                      <p class="hangye-title">{{ item.elite_name }}</p>
                      <p class="hangye-content">{{ item.doc_abstract }}</p>
                    </div> 
                  </el-carousel-item>
                </el-carousel>
                </el-col>
            </el-row>
        </div>
        <div>
            <div class="news-title">
                <span class="title-1">________</span>
                <span class="title-2">成果展示</span>
                <span class="title-3">________</span>
            </div>
            <div class="news-title2 mb-20">Our case</div>

            <div class="content" @click="handleMore(resultShowList[0].doc_id, '/XPrimaryTow', '优秀成果')" style="cursor:pointer">
                <el-row>
                    <el-col :span="24"  :offset="index > 0 ? 2 : 0">
                        <el-card :body-style="{ padding: '0px' }" class="cards">
                            <img :src="getImgSrc(resultShowList[0]?resultShowList[0].result_introduce:'')" class="cards-image">
                            <div style="" class="card-text">
                                <span class="text-title line1">{{resultShowList[0]?resultShowList[0].result_title:''}}</span>
                                <div class="text">
                                    <span class="text-l line2">{{resultShowList[0]?resultShowList[0].doc_abstract:''}}</span>
                                    <img src="../../assets/images/newHome/jiantao.png" alt="" class="text-r">
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            <div class="gekai"></div>
            <div class="content" @click="handleMore(resultShowList[1].doc_id, '/XPrimaryTow', '优秀成果')" style="cursor:pointer">
                <el-row>
                    <el-col :span="24"  :offset="index > 0 ? 2 : 0">
                        <el-card :body-style="{ padding: '0px' }" class="cards">
                            <img :src="getImgSrc(resultShowList[1]?resultShowList[1].result_introduce:'')" class="cards-image">
                            <div style="" class="card-text">
                                <span class="text-title line1">{{resultShowList[1]?resultShowList[1].result_title:''}}</span>
                                <div class="text">
                                    <span class="text-l line2">{{resultShowList[1]?resultShowList[1].doc_abstract:''}}</span>
                                    <img src="../../assets/images/newHome/jiantao.png" alt="" class="text-r">
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
            <div class="gekai"></div>
            <div class="content" @click="handleMore(resultShowList[2].doc_id, '/XPrimaryTow', '优秀成果')" style="cursor:pointer">
                <el-row>
                    <el-col :span="24"  :offset="index > 0 ? 2 : 0">
                        <el-card :body-style="{ padding: '0px' }" class="cards">
                            <img :src="getImgSrc(resultShowList[2]?resultShowList[2].result_introduce:'')" class="cards-image">
                            <div style="" class="card-text">
                                <span class="text-title line1">{{resultShowList[2]?resultShowList[2].result_title:''}}</span>
                                <div class="text">
                                    <span class="text-l line2">{{resultShowList[2]?resultShowList[2].doc_abstract:''}}</span>
                                    <img src="../../assets/images/newHome/jiantao.png" alt="" class="text-r">
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div>
            <button @click="handleJump('/XPrimaryTow?tab=2')" class="btn1">
                查看更多成果
            </button>
        </div>
        <div @click="gohome" class="qh" >进入pc端 —></div>
    </div>
  </template>
  
  <script>
  import {
    getPortalIndustryDynamicListApi,
    getPortalNewestNoticeListApi,
    getPortalResultShowListApi,
    getIndustryEliteListApi,
    getIndustryDynamicNewImageApi,
    getSearchScopeListApi
  } from "@/api"
  import Swiper from './component/swiper.vue'
  export default {
    name: 'home',
    components: {
 
    },
    data () {
      return {
        images: [
        'banner1协会工作手机端.jpg',
        'banner2关于我们 手机端.jpg',
        'banner3优秀成果 手机端.jpg',
        'banner4行业动态 手机端.jpg',
      ],
        options: [],
        searchInfo: {},
        activeName: '1',
        industryTabs:[{label:'协会动态', name: '1'},{label:'通知公告', name: '2'},{label:'行业活动', name: '3'},{label:'行业发展', name: '4'}],
        imageList:[],
        industryDynamicList:[],
        industryActivityList:[],
        newnestList:[],
        eliteList:[],
        industryEliteList:[],
        resultShowList:[],
        developListList:[],      
        selectList:[],
        selectList2:[{id:'1', label:'正文'}, {id:'2', label:'标题'}],
        index:[],
        result_introduce:''
      }
    },
    mounted() {
      var hash = window.location.hash;
      var index = hash.lastIndexOf("#target");
      if (index != -1) {
          this.$nextTick(() => {
            const returnEle = document.querySelector("#target");  //productId是将要跳转区域的id
            if (!!returnEle) {
              returnEle.scrollIntoView(true); // true 是默认的
            }
          });
      }
    },
    computed: {
    //这里设置banner 是在1100像素下高度为388px，我的banner图格式为1920X900像素
      autoHeight() {
        let _w = document.documentElement.clientWidth || document.body.clientWidth;
        if (_w <= 1600) {
          return (_w * 200) / 1000 + "px";
        } else {
          return (_w * 220) / 1100 + "px";
        }
      },
    },
    created(){
      this.init();
    },
    methods: {
      init(){
        this.imageList = []
        // 行业动态
        this.getIndustryList('1', 'init')
        //最新公告
        this.getNewestList()
        //行业精英
        this.getIndustryEliteList()
        //成果展示
        this.GetPortalResultShowList()
        //查询范围
        this.getSelectScopeList()
      },
      async getSelectScopeList(){
          const {data} = await getSearchScopeListApi()
          if (data){
              this.selectList = data
          }
      },
      async getNewImages(){
        const { data } = await getIndustryDynamicNewImageApi()
        if (data) {
          this.imageList = data
        }
      },
      async getIndustryList(tab, initFlg){
        const { data } = await getPortalIndustryDynamicListApi({industryType: tab})
        if (data) {
          this.industryDynamicList = data.docBase
          this.dataList = data.showDate
        //   for(var i = 0; i < this.datalist.length; i++){
        //     this.dataList[i].date =  /\d{4}-\d{1,2}/g.exec(this.dataList[i].date)[0]
        //     console.log(this.dataList[i].date)
        //   }
          if(initFlg==='init') {
            this.setImgList(data.docBase)
          }
        }
      },
      async getNewestList () {
        const { data } = await getPortalNewestNoticeListApi()
        if (data) {
          this.newnestList = data
        }
      },
      async getIndustryEliteList () {
        const { data } = await getIndustryEliteListApi()
        if (data) {
          this.industryEliteList = data
          this.eliteList = []
          this.industryEliteList.forEach((info, index)=> {
              let elite = info
              let imginfo = this.getImgSrc(info.elite_company)
              elite.img_url = imginfo
              this.eliteList.push(elite)
          })
        }
      },
      async GetPortalResultShowList () {
        const { data } = await getPortalResultShowListApi()
        if (data) {
          this.resultShowList = data
        }
      },
      getNewFlg(showDate){
        return Math.abs(new Date(showDate) - new Date()) < 7*24*3600*1000
      },
      goTotalSearch () {
        this.$router.push({
          path: '/XSearch',
          query: { searchInfo: JSON.stringify(this.searchInfo) }
        })
      },
      jumpDocInfo(docId, index){
        var position = ''
        var positionName = ''
        if (index === 1) {
          position = '/AssociationWork?tab=1'
          positionName = '协会工作'
        } else if (index === 2 || index === 5) {
          position = '/AssociationWork?tab=2'
          positionName = '协会工作'
        } else if (index === 3) {
          position = '/IndustryDynamic?tab=1'
          positionName = '行业动态'
        } else if (index === 4) {
          position = '/IndustryDynamic?tab=2'
          positionName = '行业动态'
        }
        this.$router.push({
            path: '/DetailsPage',
            query: {
                docId: docId,
                position: 'homePage',
                positionName: '前一页面'
            }
        }, () => {})
      },
      handleJump(path){
        this.$router.push({
            path: path,
      
        }, () => {})
      },
      jumpImgPage(flg){
        if (flg === '1' || flg === '2') {//协会工作
          this.$router.push({
            path: '/AssociationWork',
            query: { tab: flg }
          }, () => {})
        } else if (flg === '3' || flg === '4') { //行业动态
          this.$router.push({
            path: '/IndustryDynamic',
            query: { tab: flg === '3'?'1':'2' }
          }, () => {})
        }
      },
      link1(){
        this.$router.push({
            path: '/XPrimarythree?tab=1',
            query: {}
        }, () => {})
      },
      link2(){
        this.$router.push({
            path: '/XPrimaryNine?tab=1',
            query: {}
        }, () => {})
      },
      link3(){
        this.$router.push({
            path: '/XPrimaryFour?tab=1',
            query: {}
        }, () => {})
      },
      link4(){
        document.documentElement.scrollTop = 999;
      },
      link5(){
        this.$router.push({
            // path: '/ExcellentAchievements?tab=1',
            path:'/XPrimaryTow',
            query: {}
        }, () => {})
      },
      link6(){
        this.$router.push({
            path: '/XPrimaryFive?tab=1',
            query: {}
        }, () => {})
      },
      link7(){
        this.$router.push({
            path: '/XPrimarySeven?tab=1',
            query: {}
        }, () => {})
      },
      link8(){
        this.$router.push({
            path: '/XPrimarySix?tab=1',
            query: {}
        }, () => {})
      },
      link9(){
        this.$router.push({
            path: '/XPrimaryEight?tab=1',
            query: {}
        }, () => {})
      },
      gohome(){
        this.$router.push({
          path:'/home',
          query:{}
        },() => {})
      },
      // 获取图片地址
      getImgSrc(info){
          let srcSource = null
          let imgInfo
          if (typeof info === "string") {
              srcSource = info.match(/src="([^"]*)"/g);
          }
          if (srcSource) {
              let imgList = srcSource[0].split('src=')
              imgInfo = imgList[1].replace("\"","").replace("\"","")
          }
          return imgInfo
      },
      setImgList(list){
        if (list){
          list.forEach((item, index)=> {
            if (index < 1) {
              let imginfo = this.getImgSrc(item.industry_content)
              let info = {
                img: imginfo,
                title: item.industry_title
              }
              this.imageList.push(info)
            }
          })
        }
      },
      handleMore(docId, position, positionName){
        this.$router.push({
            path: '/DetailsPage',
            query: {
                docId: docId,
                position: position,
                positionName: positionName
            }
        }, () => {})
      },
      handlePersonInfo(personId){
        this.$router.push({
          path: '/DetailsTowPage',
          query: {
              personId: personId
          }
        }, () => {})
      },
      goOASystem(){
        window.open( CONFIG.LOGIN_URL, "_blank")
      },
      goRsj(url){
        window.open(url, '_blank')
      },
      handleClick (tab) {
        this.getIndustryList(tab.name)
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .home{
    height: auto;
    text-align: center;
    margin: 0 auto;
    .titleNew{
        padding: 15px 10px;
        img{
            height: 26px;
        }
        .text{
            color: #164DA0;
            font-size: 12px;
            font-weight: 600;
            line-height: 26px;
            white-space:nowrap;
        }
        .shuru{
            // width: 200px;
            height: 15px;
            line-height: 26px;    
        }
    }
    .f-d{
    width: 95%;
    overflow: auto;
    margin: auto;
    position:absolute;
    z-index: 999;
    top:130px;
    left: 0;
    right: 0;
    display: flex;
    text-align: center;
    span{
        margin: 10px auto;
        z-index: 999;
        font-size:30px;
        text-align: center;
        color: #fff;
        text-shadow: 0.1em 0.1em 0.6em #164DA0, 0 0 0.6em #164DA0, 0 0 0.6em #164DA0; //霓虹灯
        font-family:'微软雅黑';
        font-weight: 800;
    }
}
    .banner{
      position:relative;
      img{
        width: 100%;
        height: 90%;      
        object-fit:cover;
      }      
    }
    .link{
        font-size: 12px;
        margin-bottom: 15px;
        color: #164DA0;
        font-weight: 500;
        img{
            height: 42px;
            border: 1px solid rgb(226, 224, 224);
            border-radius: 10px;
            padding: 2px;
            margin-bottom: 5px;           
        }
    }
    .news{
        background:#F0F4F7;
        padding-top: 20px;
        margin-top: 25px;
        &-title{
            text-align: center;
            // height: 30px;
            .title-1{
                margin-right: 15px;
                color: rgba(0,0,0,0.06);
            }
            .title-2{
                font-weight: 500;
            }
            .title-3{
                margin-left: 15px;
                color: rgba(0,0,0,0.06);
            }
        }
        &-title2{
            font-size: 10px;
        }
    }
    .karp{
        margin-top: 20px;
        &-bkg{
            background: #fff;
            height: 247px;
            width: 200px;
            border-radius: 3px;
            text-align: center;
            margin: 0 auto;
           .karp-nei{
            height:10px;
            .karp-img{
            width:100%;
            object-fit: fill;
            }
        }
        .karp-title{
            padding-top:105px;
            width: 170px;
            margin: 0 auto;
            font-size: 13px;
            font-weight: 600;
        }  
        .karp-content{
            color: rgba(0,0,0,0.6);
            margin-bottom: 10px;
            transform: scale(0.8);
            // transform: translate(0,-10px);
        }      
        }
    }
    .hengxian{
        height: 1px;
        background-color:rgba(0,0,0,0.07);
        transform: translate(0,-10px);
        
    }
    .day{
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        transform: translate(0,-10px);
        &-time{
            color: rgba(0,0,0,0.3);
            padding: 0;
            margin: 0;
            .day-time1{
                font-size:25px;
                font-weight: 800;
                color: rgba(0,0,0,0.3);
            }
            .day-time2{
                font-size:12px;    
                transform: translate(0,-5px);          
            }
        }
        &-img{
            height: 28px;
            margin-top: 10px;
            img{
                height: 100%;
            }
        }
    }
    .home-hy{
        width:100%;
        background-image: url('../../assets/images/home/8.jpg');
        background-size:cover;
    }
    .wai{
        width: 100%;
        // margin: var(--personM) !important;
        color: #254A8A;     
        .hangye{
          margin: 35px;
        .hangye-img{
          margin-right: 15px;
        width:140px;
        height: 140px;     
        .hangye-img1{
            text-align: center;
            border-radius:90px;
            width: 100%;
            height: 100%;
        }      
    }
    &-title{
            font-size: 14px;
            font-weight: 600;
            margin-left: 15px;
        }
    &-content{
        font-size: 12px;
        color: #164DA0;
        margin-left: 15px;

    }
    }
    }
    .cards{
        &-image{ 
            text-align: center;
            margin: 0,auto;  
            width: 100%;  
            height: 200px;     
        }
        .card-text{
            text-align: start;
            padding: 14px;
            .text-title{
                font-size: 16px;  
                font-weight: 600;           
            }
            .text{
                display: flex;
                justify-content: space-between;
                margin-top: 7px;
                .text-l{
                    font-size: 14px;
                    padding-right: 25px;
                    color: rgba(0,0,0,0.8);
                }
                .text-r{
                    padding-right: 18px;
                    margin-top: 5px;
                    height:30px;
                }
            }

        }
    }
    .gekai{
    height: 10px;
    background-color: #F0F4F7;
  }
//   底部
  .bottoms{
    background-color: #0B294C;
    color: rgba(255,255,255,0.8);
    padding: 15px 0;
    .text{
        font-size: 12px;
        transform: scale(0.8);
        margin-top: 30px;
    }
    .link{
        color: rgba(255,255,255,0.8);
        font-size: 13px;
    }
  }
  .btn1{
    // background-color: #164DA0;
    background: linear-gradient(30deg,rgb(39, 105, 238) 40%,hsl(221,98%,76%)90%);
    border-radius: 20px;
    height: 35px;
    width: 150px;
    color: rgba(255,255,255,0.9);
    font-size: 14px;
    margin: 25px 0;
  }

    // .search{
    //   border: solid 2px #F0F0F0;
    //   min-width: calc(1440px * 0.85);
    //   margin: 0 auto;
    //   height: 93px;
    //   line-height: 45px;
    //   text-align: left;
    //   display: flex;
    //   img{
    //     height: 90px;
    //     margin-right: 1.25rem;
    //   }
    //   .search-mt{
    //     min-width: calc(1440px * 0.8 *0.8);
    //     margin-top: 18px;
    //     line-height: 45px;
    //     text-align: left;
    //     span{
    //       width: 9.95rem;
    //       font-size: var(--fontSize);
    //     }
    //   }
    // }
    // .title{
    //   margin: 40px 0 0 0;
    //   &-l{
    //     text-align: left;
    //     font-size: var(--contentTitleFS);
    //     font-weight: 600px;
    //     p{
    //       margin: 0 0 0 10px;
    //     }
    //     img{
    //       width: var(--contentTitleImg);
    //       margin-top: -10px;
    //     }
    //   }
    // }
    // .row-col{
    //   display: flex;
    //   label{
    //     white-space: nowrap;
    //     width: 110px;
    //   }
    // }
    .row1{
      min-width: var(--minScreen);
      &-l{
        text-align: left;
        float: left;
        .info{
          position: absolute;
          bottom: 0;
          width: 230px;
          height: 45px;
          line-height: 45px;
          text-align: center;
          margin-top: 20px;
          background: #164DA0;
          color: #fff;
          border-radius: 0;
        }
      }
      &-r{
        // margin-left: var(--tabMl);
        // border: solid 2px red;
        width: var(--imgW);
        // text-align: right;
        float: right;
        position: relative;
        img{
          width:100%;
          height: 93%;
          display: block; 
          object-fit: cover;
          float: left;
        }
        div{
          text-align: left;
          font-weight: 600;
        }
        
      }
    }
    .box-card {
      max-width: 480px;
      height: 180px;
      border-radius: 2px;
    }
    .box-card:hover{
      background: #164DA0;
      color: #fff;
    }
    .h-240{
      width: 90%;
      height: var(--rowHeight);
      padding: 0;
      margin: 0 auto;
      padding-right: 0;
      background: #277CC6;
      color: #254A8A;
      display: flex;
      color: #fff;
      text-align: left;
      .san-1{
        position: relative;
        .top {
          position: absolute;
          width:0; height:0; 
          border-width:12px; 
          border-style:solid dashed dashed; 
          border-color:#277CC6 transparent transparent;
          left: 47%;
          top: 0px;
        }
      }
      .san-2{
        position: relative;
        .top2 {
          position: absolute;
          width:0; height:0; 
          border-width:12px; 
          border-style: dashed dashed solid; 
          border-color: transparent transparent #277CC6;
          left: 48%;
          text-align: center;
          bottom: 0px;
        }
      }
  
      .bg{
        img{
          height: 100%;
          width: 100%;
        }
      }
      .content{
        margin: 20px;
        .fontW{
          font-size: var(--fontSize);
          font-weight: 600;
        }
        p{
          font-size: var(--fontSizeS);
        }
        .more{
          line-height: var(--fontMoreLH);
          cursor: pointer;
          font-size: 12px;
        }
        .arrow {
          display:inline-block;
          height:2px;
          width:40px;
          background-color:#fff;
          position:relative;
          top:0px;left:20px;
        }
        .arrow:before {
          position:absolute;
          content:"";
          width:0;
          height:0;
          border:3px solid transparent;
          border-left:8px solid #fff;
          left:40px;
          top:-2px;
        }
      }
    }
    .h-260-title{
      width: 90%;
      margin: 0 auto !important;
      padding-top: 20px;
    }  
    .h-260-title2{
      width: 100%;
      margin: 0 auto !important;
    }
    //new
    .h-260{
    width: 95%;
    height: 150px;
    margin: 15px auto !important;
    background: #fff;
    color: #254A8A;
    display: flex;
    align-items: center;
    img{
        width: 50px;
    }
    .border-r{
      height: 75px;
      // margin-top: 15px;
      border-right: solid 1px #ccc;
    }
    p{
      font-size: 12px;
      margin: 0;
    //   cursor: pointer;
    }
    a{
      color: #254A8A;
      text-decoration: none;
    }
  }
  }
  .home-m{
    width: var(--mainPageWidth);
    min-width: calc(var(--minScreen) * 0.85);
    margin: 0 auto;
  }
  .home-full-2{
    border: solid 1px #fff;
    border-bottom: solid 1px #0F4186;
    width: 100%;
    min-width: var(--minScreen);
    margin: 0 auto;
    padding: 0;
    // background-image: url('../../assets/images/home/8.jpg');
    background-size: 100% 100%;
    height: 651px;
  }
  .home-full-3{
    border: solid 1px #0F4186;
    width: 100%;
    min-width: var(--minScreen);
    margin: 0 auto;
    padding: 0;
    // background-image: url('../../assets/images/home/7.jpg');
    background-size: 100% 100%;
    height: var(--hight3);
  }
  .line{
    height: 1px;
    background-color: #164DA0;
    width: 60px;
    margin: 5px 0;
  }
  .btn{
    position: absolute;
    bottom: 0;
    width: 230px;
    height: 45px;
    line-height: 30px;
    background: #164DA0;
    color: #fff;
    border-radius: 0;
  }
  .btn-search{
    margin: 5px 0 0 5px;
    width: 100px;
    height: 38px;
    line-height: 5px;
    background: #164DA0;
    color: #fff;
    border-radius: 0;
    border: none;
  }
  .btn-g{
    position: absolute;
    bottom: 0;
    text-align: left;
    color: #ABABAB;
    font-size: 12px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .btn-s{
    padding-top: 10px;
    width: 130px;
    height: 38px;
    line-height: 15px;
    background: #164DA0;
    color: #fff;
    border-radius: 5px;
    border: none;
  }
  .mt-5{
    &-img{
      width: 35px;
      cursor: pointer;
    }
  }
  .tab-info{
    line-height: var(--ul-li-LH);
    overflow: hidden;
    text-overflow: ellipsis;
    text-overflow: -webkit-ellipsis-lastline;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;  
    img{
      margin: -5px 5px 0 0;
      width:34px; 
      line-height: 30px;
      image-rendering: -webkit-optimize-contrast; /* 针对WebKit引擎 */
      image-rendering: crisp-edges; /* WebKit引擎现不支持该值，Firefox支持 */
    }
    .tabspan{
      text-align: left;
      margin-left: 39px;
      width: 60%;
    }
  }
  .tabspan-r{
    float: right;
    line-height: var(--ul-li-LH);
  }
  .tab-more{
    border: solid 1px #ccc;
    border-radius: 5px;
    width: 85px;
    height: 35px;
    line-height: 32px;
    text-align: center;
    margin: -5px 0 0 10px;
    color: rgb(155, 154, 154);
    font-size: var(--fontSize);
    float: right;
  }
  .tab-more:hover{
    color:#ffffff;
    background: #0F4186;
  }
  .tab-more-elite{
    border: solid 1px #ccc;
    border-radius: 5px;
    width: 125px;
    height: 35px;
    line-height: 32px;
    text-align: center;
    margin: -5px 0 0 10px;
    color: rgb(155, 154, 154);
    font-size: var(--fontSize);
    float: right;
  }
  .qh{
    text-align: end;
    margin: 10px;
    color: #0F4186;
    font-weight: 600;
    font-size: 13px;
  }
  .row-tab:hover{
    color: red;
  }
  </style>
  <style lang="scss">
  .tab-r{
    line-height: 25px;
    width: 100%;
    margin-left: 10px;
    .el-tabs__item.is-active{
      color:#164DA0;
      font-size: var(--fontSizeL);
      font-weight: 700;
    }
    .el-tabs__item{
      font-size: var(--fontSizeL);
    }
    .el-tabs__active-bar{
      background: #164DA0;
    }
  }

//   .imgBoxNew {
//     position: relative;
//     .imgItem {
//       padding:5px;
//       width: 280px;
//       height: 280px;
//       text-align: center;
//       border-radius: 50%;
//       background-position: 50% 50%;
//       background-repeat: no-repeat;
//       background-size: cover;
//     }
//     .imgItem:hover{
//       width: 280px;
//       height: 280px;
//       border: 1px solid #5B84B8;
//     }
//   }
//   .imgTit{
//     color: #000;
//     margin: 10px 0;
//     line-height: 35px;
//     font-size: var(--fontSizeL);
//   }
//   .imgTit2{
//     color: rgb(4, 101, 247);
//     margin: 0 auto;
//     text-align: center;
//     line-height: 35px;
//     font-size: 16px;
//     width:280px;
//     font-weight: 600;
//   }
  .carousel{
      width: 100%;
      margin: 0;
      .a0013-con {
        padding-bottom: 120px;
        .a0013-tit {
          width: 240px;
          margin-bottom: 30px;
        }
        .a0013-swiper {
          .el-carousel__item {
            width: 300px;
            height: 500px;
            background-color: none;
          }
          .imgBox {
            position: relative;
            // .imgItem {
            //   padding:5px;
            //   width: 280px;
            //   height: 280px;
            //   text-align: center;
            //   border-radius: 50%;
            //   background-position: 50% 50%;
            //   background-repeat: no-repeat;
            //   background-size: cover;
            // }
            // .imgItem:hover{
            //   width: 280px;
            //   height: 280px;
            //   border: 1px solid #5B84B8;
            // }
          }
          .imgTit{
            color: #000;
            margin: 10px 0;
            line-height: 35px;
            font-size: var(--fontSizeL);
          }
        }
      }
  }
  </style>
  